module.exports = __webpack_public_path__ + "static/media/logo.8e88c4ff.svg";